import React from 'react'
import $ from 'jquery';

export default class contactUs extends React.Component {
    constructor(props) {
        super(props);
        this.submitForm = this.submitForm.bind(this);
        this.state = { status: '' }
    }

    render() {
        const { status } = this.state;
        return (
            <div className="form-me container p-4 ">
                <form onSubmit={this.submitForm} action="https://formspree.io/f/xgepnvpg" method="POST" >

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <input type="text" className="form-control text-field" placeholder="الاسم " name="الاسم" required />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <input type="email" className="form-control text-field" placeholder="البريد الإلكتروني" name="البريد الإلكتروني" required />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <select className="form-control text-field" name="الخدمة" required>
                                    <option value="" disabled selected>اختر الخدمة</option>
                                    <option value="دراسة الجدوى والتخطيط الاستراتيجي"> دراسة الجدوى والتخطيط الاستراتيجي </option>
                                    <option value="التعقيب والخدمات الحكومية"> التعقيب والخدمات الحكومية</option>
                                    <option value="الخدمات الإنشائية والديكور"> الخدمات الإنشائية والديكور </option>
                                    <option value="تجهيز المواد والمعدات"> تجهيز المواد والمعدات </option>
                                    <option value="إدارة المنشأة ومتابعة نقاط القوة والضعف"> إدارة المنشأة ومتابعة نقاط القوة والضعف </option>
                                    <option value="إعداد اللوائح التنظيمية والهياكل الإدارية والعقود والسياسات"> إعداد اللوائح التنظيمية والهياكل الإدارية والعقود والسياسات </option>
                                    <option value="التحليل المالي والمحاسبي">  التحليل المالي والمحاسبي</option>
                                    <option value="إدارة المخزون وإدارة الطلبات"> إدارة المخزون وإدارة الطلبات </option>
                                    <option value="إدارة الموارد البشرية"> إدارة الموارد البشرية </option>
                                    <option value="إنشاء وتطوير الهيكل التنظيمي والأقسام الإدارية"> إنشاء وتطوير الهيكل التنظيمي والأقسام الإدارية </option>
                                    <option value="تطوير ومتابعة الجودة"> تطوير ومتابعة الجودة </option>
                                    <option value="التدريب الداخلي"> التدريب الداخلي </option>
                                </select>
                            </div>
                        </div>

                    </div>
                    <div className="row">
                        <div className=" col-md-12">
                            <div className="form-group">
                                <textarea className="form-control text-field" name="رسالتك" placeholder="رسالتك"
                                    rows="3" required></textarea>
                            </div>
                        </div>
                    </div>
                    {status === "SUCCESS" ? <p>شكراً! تم الإرسال بنجاح</p> : <button className="btn submit-btn mb-3 " type="submit">إرسال</button>}

                    {status === "ERROR" && <p>حدث خطأ، الرجاء المحاولة مرة اخرى</p>}
                    {status === "EMPTY" && <p className="error-msg d-none  mt-3" id="error-msg">جميع الحقول مطلوبة</p>}

                </form>
            </div>
        )
    }
    submitForm = (ev) => {
        ev.preventDefault();
        if ($(".text-field").val()) {
            const form = ev.target;
            const data = new FormData(form);
            const xhr = new XMLHttpRequest();
            xhr.open(form.method, form.action);
            xhr.setRequestHeader("Accept", "application/json");
            xhr.onreadystatechange = () => {
                if (xhr.readyState !== XMLHttpRequest.DONE) return;
                if (xhr.status === 200) {
                    form.reset();
                    this.setState({ status: "SUCCESS" });

                } else {
                    this.setState({ status: "ERROR" });
                }
            };
            xhr.send(data);

        } else {
            this.setState({ status: "EMPTY" });
        }
    }
}
